import { render, staticRenderFns } from "./bodyAgility.vue?vue&type=template&id=97b7392e&scoped=true"
import script from "./bodyAgility.vue?vue&type=script&lang=js"
export * from "./bodyAgility.vue?vue&type=script&lang=js"
import style0 from "./bodyAgility.vue?vue&type=style&index=0&id=97b7392e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7392e",
  null
  
)

export default component.exports